import React from 'react';
import { motion } from 'framer-motion';
// import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onCancel?: () => void; // NEW: Optional handler for the cancel button
  tipMessage?: string; // NEW: Optional tip message
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar Exclusão',
  cancelText = 'Cancelar',
  onCancel,
  tipMessage,
}) => {
  // const { t } = useTranslation();

  if (!isOpen) return null;

  // Determine the cancel action: use onCancel if provided, otherwise use onClose
  const handleCancel = onCancel || onClose;

  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      onClick={onClose}
    >
      <motion.div
        className="relative w-full max-w-sm rounded-xl bg-white dark:bg-gray-800 shadow-2xl border border-gray-200 dark:border-gray-700/50 p-6 flex flex-col gap-6"
        initial={{ y: 50, opacity: 0, scale: 0.95 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        exit={{ y: 50, opacity: 0, scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex flex-col gap-1">
          <h2 className="text-xl font-bold text-red-600 dark:text-red-400 flex items-center gap-2">
            <span className="material-symbols-outlined text-2xl">warning</span>
            {title}
          </h2>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">{message}</p>
        </div>

        {/* Tip Message (NEW) */}
        {tipMessage && (
          <div className="p-3 rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700">
            <p className="text-xs text-blue-800 dark:text-blue-300 font-medium">
              {tipMessage}
            </p>
          </div>
        )}

        {/* Footer / Actions */}
        <div className="flex justify-end gap-3 pt-2">
          <motion.button
            type="button"
            onClick={handleCancel}
            className="flex h-12 w-full sm:w-auto cursor-pointer items-center justify-center overflow-hidden rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 text-sm font-bold leading-normal tracking-[0.015em] px-6 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {cancelText}
          </motion.button>

          <motion.button
            type="button"
            onClick={onConfirm}
            className="flex h-12 w-full sm:w-auto cursor-pointer items-center justify-center overflow-hidden rounded-lg bg-red-600 text-white gap-2 text-sm font-bold leading-normal tracking-[0.015em] px-6 hover:bg-red-700 transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {confirmText}
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ConfirmationModal;